import {
  IoHomeOutline,
  IoLogOutOutline,
  IoMailOutline,
  IoPersonOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import { useCallback, useContext, useEffect, useState } from "react";
import { ChatContext } from "./../../context/ChatContext";
import { Link } from "react-router-dom";
import Popover from "../common/Popover";
import Navigation from "./Navigation";
import authService from "./../../services/authService";
import chatService from "../../services/chatService";

const Header = () => {
  const user = authService.getCurrentUser();

  const [connection] = useContext(ChatContext);
  const [unreadMessages, setUnreadMessages] = useState([]);

  const handleReceive = useCallback(
    async (mounted) => {
      connection.on("ReceiveUnreadMessage", (unread) => {
        if (mounted)
          setUnreadMessages((unreadMessages) => {
            const data = [...unreadMessages];

            const index = data.findIndex((i) => i.room_id === unread.roomId);

            const item = { ...unread };
            item["message_id"] = item.messageId;
            item["room_id"] = item.roomId;
            item["text_message"] = item.textMessage;

            if (index === -1) {
              data.push(item);
            } else {
              data[index] = item;
            }

            return data;
          });
      });
    },
    [connection]
  );

  useEffect(() => {
    let mounted = true;

    handleReceive(mounted);

    return () => {
      mounted = false;
    };
  }, [handleReceive]);

  const fetchUnreadMessages = useCallback(async (mounted) => {
    const { result } = await chatService.getUnreadMessagesAsync();
    if (mounted) setUnreadMessages(result);
  }, []);

  useEffect(() => {
    let mounted = true;

    fetchUnreadMessages(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchUnreadMessages]);

  const handleLogout = () => {
    authService.logout();
    window.location = "/login";
  };

  const action_items = [
    {
      content: (
        <button
          key="1"
          onClick={handleLogout}
          className="flex justify-between items-center p-3 hover:bg-gray-50 focus:outline-none"
        >
          <IoLogOutOutline className="text-gray-400" />
          <p className="text-sm text-gray-400">Logout</p>
        </button>
      ),
    },
  ];

  const navigation_items = [
    {
      id: 1,
      title: "Home",
      url: "/",
      icon: <IoHomeOutline className="text-blue-400" />,
    },
    {
      id: 2,
      title: "Accounts",
      url: "/accounts",
      icon: <IoPersonOutline className="text-blue-400" />,
    },
    {
      id: 3,
      title: (
        <div className="flex">
          <p>Messages</p>
          {unreadMessages.length > 0 && (
            <div className="ml-2">
              <div className="flex">
                <span className="animate-ping absolute inline-flex h-4 w-4 rounded-full bg-red-400 opacity-75"></span>
                <div className="relative rounded-full h-4 w-4">
                  <div className="text-xs text-center text-red-500">
                    {unreadMessages.length}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ),
      url: "/messages",
      icon: <IoMailOutline className="text-blue-400" />,
    },
    {
      id: 4,
      title: "Settings",
      url: "/settings",
      icon: <IoSettingsOutline className="text-blue-400" />,
    },
  ];

  return (
    <header className="fixed bg-white max-w-full w-full z-30">
      <div className="border-b border-gray-100 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex justify-between items-center">
            <Link to="/">
              <span className="sr-only">Medtax Solutions Inc.</span>
              <img
                className="h-7 w-auto"
                src="/medtax-logo.png"
                alt="medtax-logo"
              />
            </Link>
            <div className="flex justify-end items-center lg:w-0 lg:flex-1">
              <Popover title={user.name} items={action_items} />
            </div>
          </div>
        </div>
      </div>
      <div className="border-b-2 border-gray-100 py-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <Navigation items={navigation_items} />
        </div>
      </div>
    </header>
  );
};

export default Header;
